import HTTP from "./ajax";
import {
  apiEndpoints as ApiEndpoints,
  countryCodeFromDomain as CountryCodeFromDomain,
} from "./apiEndpoints";
import Utility from "../helpers/utility";
import ApiKeys from "./apiKeys";

const GEOCODE_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.GEOCODE}?latitude=${payload.latitude}&longitude=${
      payload.longitude
    }&v=${Utility.randomnumber()}`,
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};

const GOOGLE_GEOLOCATION_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.GOOGLE_GEO_LOCATION}?key=${
      ApiKeys.GOOGLE_MAPS_API_KEY
    }&v=${Utility.randomnumber()}`,
    payload,
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};

const STORE_DETAILS_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.LOCATOR_STORES}/${
      payload.storeId
    }?&v=${Utility.randomnumber()}`,
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};

const LOCATOR_STORES_API = async ({ headers, payload }) => {
  let res;
  for (var i = 0; i < 1; i++) {
    try {
      res = await HTTP.post(
        `${ApiEndpoints.LOCATOR_STORES}?v=${Utility.randomnumber()}`,
        payload,
        {
          headers: headers,
          timeout: 5000,
        },
      );
      if (res?.data?.data?.addressComponent) {
        break;
      }
    } catch (e) {
      res = e;
    }
  }
  return res;
};

const NEAREST_STORE_API = async ({ headers, payload }) => {
  let res;
  for (var i = 0; i < 1; i++) {
    try {
      res = await HTTP.post(
        `${ApiEndpoints.NEAREST_STORE}?v=${Utility.randomnumber()}`,
        payload,
        {
          headers: headers,
          timeout: 5000,
        },
      );
      if (res?.data?.data?.addressComponent) {
        break;
      }
    } catch (e) {
      res = e;
    }
  }
  return res;
};

const LOCATOR_STORES_TAKEAWAY_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.LOCATOR_STORES_TAKEAWAY}?orderDeliveryType=${
      payload.orderType
    }&latitude=${payload.latitude}&longitude=${payload.longitude}&${
      payload.extra
    }&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const LOCATOR_STORES_V3_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.LOCATOR_STORES_TAKEAWAY}?latitude=${payload.latitude}&longitude=${payload.longitude}`,
    payload,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const STORE_OFFERS_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.STORE_OFFERS}?view=HOME_V3&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const LEFT_MENU_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${
      ApiEndpoints.LEFT_MENU
    }/${payload}/leftMenu?new=true&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const APPLY_WELCOME_OFFER_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.APPLY_WELCOME_OFFER}/${payload.cartId}/promo/${
      payload.promoCode
    }?${
      payload.isBinOffer ? "includePartnerOffer=true&" : ""
    }v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const REMOVE_WELCOME_OFFER_API = async ({ headers, payload }) => {
  return HTTP.delete(
    `${ApiEndpoints.APPLY_WELCOME_OFFER}/${payload.cartId}/promo/${
      payload.promoCode
    }?${
      payload.isBinOffer ? "includePartnerOffer=true&" : ""
    }v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const OFFER_TNC_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.OFFER_TNC}/${payload?.href}?v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const USER_LOYALTY_API = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.USER_LOYALTY}?v=${Utility.randomnumber()}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const LOYALTY_STATEMENT_API = async ({ headers, payload }) => {
  const { api } = payload;
  return HTTP.get(`${api}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const WALLET_CASHBACK_API = async ({ headers, payload }) => {
  const { api } = payload;
  return HTTP.get(`${api}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const STATIC_WIDGET_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${payload.endPoint}?site=${payload.site}&lang=${payload.lang}&platform=${
      payload.platform
    }&page=${payload.page}&deliveryType=${
      payload.deliveryType
    }&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const REGISTER_LOYALTY_API = async ({ headers, payload }) => {
  return HTTP.post(`${ApiEndpoints.REGISTER_LOYALTY}?enroll=true`, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const PERSONALIZATION_ITEMS_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.PERSONALIZATION_ITEMS}?v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const MENU_SEQUENCING_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.MENU_SEQUENCING}?storeId=${
      payload.storeId
    }&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const WALLET_BALANCE_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.WALLET_BALANCE}?v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const OPT_OUT_LOYALTY_API = async ({ headers, payload }) => {
  const { api } = payload;
  return HTTP.get(`${api}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const ANONYNMOUS_USER_API = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.ANONYMOUS_USER}?v=${Utility.randomnumber()}`,
    payload,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const TRACK_ORDER_API = async ({ headers, payload }) => {
  const { mobile, orderId, userId } = payload;
  return await HTTP.get(
    `${ApiEndpoints.TRACK_ORDERS}?mobile=${mobile}&order=${orderId}&userId=${userId}`,
    {
      headers: headers,
    },
  );
};

const PIZZA_TOPPING_API = async ({ headers, payload }) =>
  await HTTP.get(
    `${
      ApiEndpoints.PIZZA_TOPPING
    }/${payload}/toppings/data?v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  );

const PREVIOUS_ORDER_API = async ({ headers, payload }) =>
  await HTTP.get(
    `${ApiEndpoints.PREVIOUS_ORDER}${localStorage.storeId}/reorder-item?limit=10`,
    {
      headers: headers,
    },
  );

const OLD_PREVIOUS_ORDER_API = async ({ headers, payload }) =>
  await HTTP.get(`${ApiEndpoints.OLD_PREVIOUS_ORDER}/orders?userId=244371299`, {
    headers: headers,
  });

const ESTIMENT_ORDER_TIME_API = async ({ headers, payload }) =>
  await HTTP.get(`${ApiEndpoints.ESTIMENT_ORDER_TIME}`, {
    headers: headers,
  });

const SEND_TRACKER_STATUS_API = async ({ headers, payload }) => {
  return HTTP.post(`${ApiEndpoints.SEND_TRACKER_STATUS}`, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const PAYMENT_OFFER_TNC_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.PAYMENT_OFFER_TNC}?offerId=${payload.offerId}&langId=${
      payload.langId
    }&platform=${payload.platform}&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const USER_ACTIVITY_TRACKING_API = async (headers, payload) => {
  const uatFlag =
    window?._siteProps_?.props?.userActivityTrackingSwitch == "true"
      ? true
      : false;
  if (uatFlag) {
    return HTTP.post(`${ApiEndpoints.USER_ACTIVITY_TRACKING}`, payload, {
      headers: headers,
    })
      .then((res) => {
        /*console.log(JSON.stringify(payload))*/
      })
      .catch((err) => {
        console.error("User activity tracking Api error:::" + err);
        return err;
      });
  }
};

const GET_PWA_CONFIG = async ({ headers, payload }) => {
  return HTTP.get(ApiEndpoints.PWA_CONFIG_API, { headers: headers }).catch(
    (err) => {
      return err;
    },
  );
};

const GET_APP_CONFIG = async ({ headers, payload }) => {
  return HTTP.get(ApiEndpoints.APP_CONFIG_API, { headers: headers }).catch(
    (err) => {
      return err;
    },
  );
};

const SIGN_IN_MINIAPP = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.LOGIN_MINIAPP}/${payload.vendor}/auth`,
    payload,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const GET_SAVED_ADDRESS = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.SAVED_ADDRESS}/${payload.userId}/addresses`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const GET_NPS_CSAT_HOME_WIDGET = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.NPS_CSAT_HOME_WIDGET}?&v=${Utility.randomnumber()}`,
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};

const NPS_CSAT_DISMISS_HOME_WIDGET = async ({ headers, payload }) => {
  return HTTP.delete(
    `${ApiEndpoints.NPS_CSAT_DISMISS_HOME_WIDGET}${
      payload.widgetId
    }?&v=${Utility.randomnumber()}`,
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};

const GENERATE_DELETE_USER_OTP = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.DELETE_USER_ACCOUNT}/${payload.mobile}?&userId=${payload.userId}&mobile=${payload.mobile}`,
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};
const CONFIRM_USER_DELETED = async ({ headers, payload }) => {
  return HTTP.post(
    `${ApiEndpoints.CONFIRM_ACCOUNT_DELETE}/${payload.mobile}`,
    { otp: payload.otp },
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};
const FINGERPRINT_INFO = async ({ headers, payload }) => {
  const { detectorData } = payload;
  return HTTP.post(`${ApiEndpoints.FINGERPRINT_INFO}`, detectorData, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const GET_MULTIPLE_RECOMMENDATION_API = async ({ headers, payload }) => {
  const { api, apiPayload, payloadObj } = payload;
  let queryParam = `store_id=${apiPayload.storeId}&user_frequency=${apiPayload.userFrequency}&platform=${apiPayload.platform}&sequence_set=${apiPayload.sequenceSet}&limit=${apiPayload.limit}`;

  let arrayToExclude = [
    "storeId",
    "store_id",
    "userFrequency",
    "user_frequency",
    "platform",
    "sequenceSet",
    "sequence_set",
    "limit",
  ];

  if ("name" in payloadObj) {
    queryParam = queryParam + `&name=${apiPayload.name}`;
    arrayToExclude.push("name");
  } else if ("group_name" in payloadObj) {
    queryParam = queryParam + `&group_name=${apiPayload.name}`;
    arrayToExclude.push("group_name");
  }

  for (const key in payloadObj) {
    if (!arrayToExclude.includes(key)) {
      queryParam = queryParam + `&${key}=${payloadObj[key]}`;
    }
  }

  return await HTTP.get(`${api}?${queryParam}`, {
    headers: headers,
  });
};

const GET_CONFIGURED_CATEGORY_API = async ({ headers, payload }) => {
  const { store_id, tenant, menu_type } = payload.apiPayload;
  return await HTTP.get(
    `${payload.api}?store_id=${store_id}&tenant=${tenant}&menu_type=${menu_type}`,
    {
      headers: headers,
    },
  );
};

const GET_SERVICE_GUARANTEE_BREAKDOWN = async ({ headers, payload }) => {
  return await HTTP.get(`${ApiEndpoints.SERVICE_GUARANTEE_BREAKDOWN}`, {
    headers: headers,
  });
};

const GET_LOTTIE_DATA = async ({ headers, payload }) => {
  return await HTTP.get(payload, {
    headers: headers,
  });
};

const GET_SPLASH_SCREEN = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.SPLASH_SCREEN_API}?site=${payload.site}&lang=${
      payload.lang
    }&platform=${payload.platform}&page=${payload.page}&deliveryType=${
      payload.deliveryType
    }&v=${Utility.randomnumber()}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const GET_BPG_DATA = async ({ headers, payload }) => {
  const {
    site = "",
    platform = "",
    page = "",
    orderType = "",
    userFrequency = "",
    storeId = "",
    groupFilter = "",
  } = payload;

  const newHeader = {
    ...headers,
    "Content-Type": "application/json",
  };

  return HTTP.get(
    `${ApiEndpoints.BEST_PRICE_GUARANTEE_API}?site=${site}&platform=${platform}&page=${page}&orderType=${orderType}&userFrequency=${userFrequency}&storeId=${storeId}&groupFilter=${groupFilter}`,
    {
      headers: newHeader,
    },
  ).catch((err) => {
    return err;
  });
};

const ORDER_TRACKING_API = async ({ headers, payload }) => {
  return HTTP.get(
    `${ApiEndpoints.ORDER_TRACKER_SUMMARY}/status?orderId=${payload?.orderId}&riderTracker=true`,
    { headers: headers },
  ).catch((err) => {
    return err;
  });
};

const GET_ACTIVE_ORDERS = async ({ headers, payload }) => {
  return HTTP.get(`${ApiEndpoints.GET_ORDERS_V3}?active_orders=true&fetchAdvanceOrders=${payload?.fetchAdvanceOrders}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

export const GET_SG_ONECLICK_DATA = async ({ headers, payload }) => {
  const { apiUrl } = payload;
  return HTTP.get(`${ApiEndpoints.SG_ONECLICK_API}${apiUrl}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

export const SG_CREATE = async ({ headers, payload }) => {
  return HTTP.post(`${ApiEndpoints.SG_CREATE}`, payload, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

export const SG_ONECLICK_STATUS = async ({ headers, payload }) => {
  const { eventId, orderId } = payload;
  return HTTP.get(
    `${ApiEndpoints.SG_ONECLICK_STATUS}?eventId=${eventId}&orderId=${orderId}&fetchFromPos=false`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

export const TRANSACTION_API = async ({ headers, payload }) => {
  return await HTTP.get(
    `${ApiEndpoints.TRANSACTION}/${payload.$transactionId}`,
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const GET_STORE_STRESS_API = async ({ headers, payload }) => {
  return await HTTP.post(`${ApiEndpoints.STORE_STRESS_RESIGTER}`, payload, {
    headers: headers,
  });
};

const BRIDGING_API = async ({ headers, payload }) => {
  return await HTTP.post(
    `${payload.api}`,
    {
      token: payload.token,
    },
    {
      headers: headers,
    },
  ).catch((err) => {
    return err;
  });
};

const CHEESY_POTP_INFO_API = async ({ headers, payload }) => {
  const { api } = payload;
  return HTTP.get(`${api}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const CHEESY_FAQ_DATA_API = async ({ headers, payload }) => {
  const { api } = payload;
  return HTTP.get(`${api}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const LOYALTY_MENU_DATA_API = async ({ headers, payload }) => {
  const { api } = payload;
  return HTTP.get(`${api}`, {
    headers: headers,
  }).catch((err) => {
    return err;
  });
};

const DITA_PICK_USER_ACTION_API = async ({ headers, payload }) => {
  return await HTTP.post(`${ApiEndpoints.DITA_PICK_USER_ACTION}`, payload, {
    headers: headers,
  });
};

export default {
  GEOCODE_API,
  GOOGLE_GEOLOCATION_API,
  LOCATOR_STORES_API,
  STORE_DETAILS_API,
  NEAREST_STORE_API,
  LOCATOR_STORES_TAKEAWAY_API,
  STORE_OFFERS_API,
  LEFT_MENU_API,
  APPLY_WELCOME_OFFER_API,
  REMOVE_WELCOME_OFFER_API,
  OFFER_TNC_API,
  USER_LOYALTY_API,
  STATIC_WIDGET_API,
  REGISTER_LOYALTY_API,
  BRIDGING_API,
  PERSONALIZATION_ITEMS_API,
  MENU_SEQUENCING_API,
  WALLET_BALANCE_API,
  ANONYNMOUS_USER_API,
  TRACK_ORDER_API,
  PIZZA_TOPPING_API,
  PREVIOUS_ORDER_API,
  ESTIMENT_ORDER_TIME_API,
  SEND_TRACKER_STATUS_API,
  PAYMENT_OFFER_TNC_API,
  USER_ACTIVITY_TRACKING_API,
  GET_PWA_CONFIG,
  GET_APP_CONFIG,
  SIGN_IN_MINIAPP,
  GET_SAVED_ADDRESS,
  OLD_PREVIOUS_ORDER_API,
  GET_NPS_CSAT_HOME_WIDGET,
  NPS_CSAT_DISMISS_HOME_WIDGET,
  GET_MULTIPLE_RECOMMENDATION_API,
  LOCATOR_STORES_V3_API,
  GET_CONFIGURED_CATEGORY_API,
  GENERATE_DELETE_USER_OTP,
  CONFIRM_USER_DELETED,
  FINGERPRINT_INFO,
  GET_SERVICE_GUARANTEE_BREAKDOWN,
  GET_LOTTIE_DATA,
  GET_SPLASH_SCREEN,
  GET_BPG_DATA,
  ORDER_TRACKING_API,
  GET_ACTIVE_ORDERS,
  GET_SG_ONECLICK_DATA,
  SG_CREATE,
  SG_ONECLICK_STATUS,
  TRANSACTION_API,
  GET_STORE_STRESS_API,
  CHEESY_POTP_INFO_API,
  CHEESY_FAQ_DATA_API,
  LOYALTY_STATEMENT_API,
  OPT_OUT_LOYALTY_API,
  WALLET_CASHBACK_API,
  LOYALTY_MENU_DATA_API,
  DITA_PICK_USER_ACTION_API,
};
